import Shape from './Shape.js';

export default class MainShape extends Shape {
  #properties = [];
  #connections = [];

  constructor(id, name, type, position) {
    super(id, name, type, position);
  }

  addProperty(prop) {
    this.#properties.push(prop);
  }

  getPropertyAt(index) {
    return this.#properties[index];
  }

  getProperties() {
    return this.#properties;
  }

  addConnection(connection) {
    this.#connections.push(connection);
  }

  getConnectionAt(index) {
    return this.#connections[index];
  }

  getConnections() {
    return this.#connections;
  }

  #getSavedPropertiesArray() {
    return this.#properties.map(prop => prop.getSavedObject());
  }

  #getConnectors() {
    const allconnectors = this.#properties
      .map(prop => prop.getConnector())
      .filter(connector => connector);

    return allconnectors
      .filter(
        (connector, index) =>
          index ===
          allconnectors.findIndex(inner => inner.getId() === connector.getId())
      )
      .map(connector => connector.getSavedObject());
  }

  getSavedObject() {
    return {
      name: this.getName(),
      type: this.getType(),
      position: this.getPosition(),
      properties: this.#getSavedPropertiesArray(),
      connectors: this.#getConnectors(),
    };
  }
}
